export const ROLES = [
    'admin',
    'administrativ',
    'marketing',
    'depozit',
    'contabilitate',
    'vanzari',
    /**
     * Manager peste agenții de vânzări: vede portofoliile tuturor, mai puțin conturile naționale.
     *
     * Exista deja ca pozitie — Claudia Pasca si Adrian Mihai —, dar nu si ca rol: li se dadeau
     * permisiuni punctuale, invizibile in matricea de drepturi. Victor le-a si semnalat, uitandu-se
     * la ce pot face: „aici nu au de ce sa aiba ei drepturi" (28.09.2026). Cand o pozitie se scrie
     * din exceptii, nimeni nu mai stie peste un an de ce doi oameni vad altceva decat colegii lor.
     *
     * Conturile nationale — Farmexim, Fildas, Dr.Max, Farmacia Tei, BebeTei — raman la Victor si
     * nu intra in vederea managerilor. Vezi `PharmaClient.contNational`.
     *
     * EXCEPTIE, Profitabilitatea (03.11.2026): acolo managerul vede tot — conturile nationale si
     * costurile agentilor, cu salariile. Mădălin: „nu ii ascundem nimic [...] va ramane doar Claudia,
     * care practic devine director de vanzari”. Accesul e pe rol: oricine il are vede salariile.
     */
    'manager_vanzari',
];
export function isRole(value) {
    return typeof value === 'string' && ROLES.includes(value);
}
/**
 * Cine lucreaza cu deconturile TUTUROR — situatia lunii, notele contabile, exportul, bonurile
 * fiecaruia. Ceilalti isi vad doar decontul lor, in „Decontul meu" (`/upload/me`).
 *
 * Rol, nu pagina: dreptul de citire vine din pagina bifata, fara plafon (`lib/access.ts`), iar
 * pagina de HR fusese data in iulie 2026 si unor agenti de vanzari — care vedeau astfel deconturile
 * tuturor colegilor, cu sumele lor (14.10.2026, backlog S15).
 */
export const ROLURI_DECONTURI_ECHIPA = ['admin', 'contabilitate', 'administrativ'];
export function vedeDeconturileEchipei(role) {
    return !!role && ROLURI_DECONTURI_ECHIPA.includes(role);
}
/**
 * Flota Rompetrol — masinile, carburantul, tot ce e acolo (Madalin, 28.10.2026, prioritate zero):
 * agentii din Vanzari NU o vad; ramane la Managerii Vanzari. Ca la deconturi: rol, nu pagina —
 * pagina bifata rolului sau omului nu mai ajunge, fiindca citirile n-au plafon (`lib/access.ts`).
 */
export const ROLURI_FLOTA = ROLES.filter((r) => r !== 'vanzari');
export function vedeFlota(role) {
    return !!role && ROLURI_FLOTA.includes(role);
}
//# sourceMappingURL=roles.js.map